import React from 'react';

import TextBox from '../../../../ui/TextBox';
import Date from '../../../../ui/Date';

import { now } from '../../../../dateUtils';
import InlineInputControlRow from "../../../../ui/layout/InlineInputControlRow";
import { HblStatusViewModel } from '../../../../fms.core/HblStatusViewModel';
import InlineInputControlRowNoLabel from '../../../../ui/layout/InlineInputControlRowNoLabel';
import BlStatusRow from '../../../common/BlStatusRow';
import BlueTitleRow from '../../../../ui/BlueTitleRow';

function HblMilestone({
  blStatus,
  onChange,
  isView,
  user
}: {
  blStatus: HblStatusViewModel,
  onChange: (x:Partial<HblStatusViewModel>) => void,
  user: string,
  isView: boolean,
}) {
  return (
    <div>
      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <div style={{marginLeft: '30px'}}>
            <InlineInputControlRow label="HBL #" bold mode="w115">
              <div style={{width: '130px'}}>
                <TextBox disabled value={blStatus.hblNo ?? ''} />
              </div>
            </InlineInputControlRow>
          </div>
        </div>

        <div style={{marginLeft: '40px', width: '325px'}}>
        </div>
      </div>

      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <div style={{marginLeft: '30px'}}>
            <InlineInputControlRow label="Issue Date / By" mode="w115">
              <div style={{display: 'flex'}}>
                <div style={{width: '80px'}}>
                  <Date disabled value={blStatus.issueDate} />
                </div>
                <div style={{width: '50px'}}>
                  <TextBox style={{borderLeft: 'none'}} value={blStatus.issuedBy} disabled />
                </div>
              </div>
            </InlineInputControlRow>
          </div>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="OP Close"
              disabled
              checked={!!blStatus.opClosed}
              dateTime={blStatus.opCloseDate}
              onDateTimeChange={() => {}}
              userId={blStatus.opClosedBy}
              onToggle={() => {
                // window.console.log(checked);
              }}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Period Close"
              disabled
              checked={blStatus.actClosed}
              dateTime={blStatus.actClosed ? blStatus.actCloseDate : ''}
              onDateTimeChange={() => {}}
              userId={blStatus.actClosed ? blStatus.actClosedBy : ''}
              onToggle={() => {
                // window.console.log(checked);
              }}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>
        </div>
      </div>

      <div style={{marginTop: '10px'}}>
        <BlueTitleRow title={<span style={{paddingLeft: '14px'}}>B/L Status</span>} />
      </div>

      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Tracker"
              disabled={isView}
              checked={!!blStatus.trackerChk}
              onToggle={trackerChk => onChange({
                trackerChk,
                trackerDate: trackerChk ? now() : null,
                trackerBy: trackerChk ? user : '',
                })}
              dateTime={blStatus.trackerDate}
              onDateTimeChange={trackerDate => onChange({trackerDate, trackerBy: trackerDate ? blStatus.trackerBy : '', trackerChk: trackerDate ? blStatus.trackerChk : false})}
              userId={blStatus.trackerBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Last Tracked"
              disabled={isView}
              checked={!!blStatus.lastTrackChk}
              onToggle={lastTrackChk => onChange({
                lastTrackChk,
                lastTrackDate: lastTrackChk ? now() : null,
                lastTrackBy: lastTrackChk ? user : '',
                })}
              dateTime={blStatus.lastTrackDate}
              onDateTimeChange={lastTrackDate => onChange({lastTrackDate, lastTrackBy: lastTrackDate ? blStatus.lastTrackBy : '', lastTrackChk: lastTrackDate ? blStatus.lastTrackChk : false})}
              userId={blStatus.lastTrackBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Book Confirm by Cust."
              disabled={isView}
              checked={!!blStatus.emptyRetChk}
              onToggle={emptyRetChk => onChange({
                emptyRetChk,
                emptyRetDate: emptyRetChk ? now() : null,
                emptyRetBy: emptyRetChk ? user : '',
                })}
              dateTime={blStatus.emptyRetDate}
              onDateTimeChange={emptyRetDate => onChange({emptyRetDate, emptyRetBy: emptyRetDate ? blStatus.emptyRetBy : '', emptyRetChk: emptyRetDate ? blStatus.emptyRetChk : false})}
              userId={blStatus.emptyRetBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Book Confirm"
              disabled={isView}
              checked={!!blStatus.anPrtChk}
              onToggle={anPrtChk => onChange({
                anPrtChk,
                anPrtDate: anPrtChk ? now() : null,
                anPrtBy: anPrtChk ? user : '',
                })}
              dateTime={blStatus.anPrtDate}
              onDateTimeChange={anPrtDate => onChange({anPrtDate, anPrtBy: anPrtDate ? blStatus.anPrtBy : '', anPrtChk: anPrtDate ? blStatus.anPrtChk : false})}
              userId={blStatus.anPrtBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive Shipping Docs"
              disabled={isView}
              checked={!!blStatus.isRcvDoc}
              onToggle={isRcvDoc => onChange({
                isRcvDoc,
                rcvDocDate: isRcvDoc ? now() : null,
                rcvDocDateBy: isRcvDoc ? user : '',
                })}
              dateTime={blStatus.rcvDocDate}
              onDateTimeChange={rcvDocDate => onChange({rcvDocDate, rcvDocDateBy: rcvDocDate ? blStatus.rcvDocDateBy : '', isRcvDoc: rcvDocDate ? blStatus.isRcvDoc : false})}
              userId={blStatus.rcvDocDateBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="File AMS"
              disabled={isView}
              checked={!!blStatus.inlandNtcChk}
              onToggle={inlandNtcChk => onChange({
                inlandNtcChk,
                inlandNtcDate: inlandNtcChk ? now() : null,
                inlandNtcBy: inlandNtcChk ? user : '',
                })}
              dateTime={blStatus.inlandNtcDate}
              onDateTimeChange={inlandNtcDate => onChange({inlandNtcDate, inlandNtcBy: inlandNtcDate ? blStatus.inlandNtcBy : '', inlandNtcChk: inlandNtcDate ? blStatus.inlandNtcChk : false})}
              userId={blStatus.inlandNtcBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Customs Clearance"
              disabled={isView}
              checked={!!blStatus.doConfirmChk}
              onToggle={doConfirmChk => onChange({
                doConfirmChk,
                doConfirmDate: doConfirmChk ? now() : null,
                doConfirmBy: doConfirmChk ? user : '',
                })}
              dateTime={blStatus.doConfirmDate}
              onDateTimeChange={doConfirmDate => onChange({doConfirmDate, doConfirmBy: doConfirmDate ? blStatus.doConfirmBy : '', doConfirmChk: doConfirmDate ? blStatus.doConfirmChk : false})}
              userId={blStatus.doConfirmBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send HBL"
              disabled={isView}
              checked={!!blStatus.doSentChk}
              onToggle={doSentChk => onChange({
                doSentChk,
                doSentDate: doSentChk ? now() : null,
                doSentBy: doSentChk ? user : '',
                })}
              dateTime={blStatus.doSentDate}
              onDateTimeChange={doSentDate => onChange({doSentDate, doSentBy: doSentDate ? blStatus.doSentBy : '', doSentChk: doSentDate ? blStatus.doSentChk : false})}
              userId={blStatus.doSentBy}
            />
          </InlineInputControlRowNoLabel>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Dock Receipt"
              disabled={isView}
              checked={!!blStatus.ddpChk}
              onToggle={ddpChk => onChange({
                ddpChk,
                ddpDate: ddpChk ? now() : null,
                ddpBy: ddpChk ? user : '',
                })}
              dateTime={blStatus.ddpDate}
              onDateTimeChange={ddpDate => onChange({ddpDate, ddpBy: ddpDate ? blStatus.ddpBy : '', ddpChk: ddpDate ? blStatus.ddpChk : false})}
              userId={blStatus.ddpBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Arrange Trucking"
              disabled={isView}
              checked={!!blStatus.examOnChk}
              onToggle={examOnChk => onChange({
                examOnChk,
                examOnDate: examOnChk ? now() : null,
                examOnBy: examOnChk ? user : '',
                })}
              dateTime={blStatus.examOnDate}
              onDateTimeChange={examOnDate => onChange({examOnDate, examOnBy: examOnDate ? blStatus.examOnBy : '', examOnChk: examOnDate ? blStatus.examOnChk : false})}
              userId={blStatus.examOnBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive Cargo"
              disabled={isView}
              checked={!!blStatus.isRcvCargo}
              onToggle={isRcvCargo => onChange({
                isRcvCargo,
                rcvCargoDate: isRcvCargo ? now() : null,
                rcvCargoDateBy: isRcvCargo ? user : '',
                })}
              dateTime={blStatus.rcvCargoDate}
              onDateTimeChange={rcvCargoDate => onChange({rcvCargoDate, rcvCargoDateBy: rcvCargoDate ? blStatus.rcvCargoDateBy : '', isRcvCargo: rcvCargoDate ? blStatus.isRcvCargo : false})}
              userId={blStatus.rcvCargoDateBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Deliver to Carrier"
              disabled={isView}
              checked={!!blStatus.isDlvrCarr}
              onToggle={isDlvrCarr => onChange({
                isDlvrCarr,
                dlvrCarrDate: isDlvrCarr ? now() : null,
                dlvrCarrDateby: isDlvrCarr ? user : '',
                })}
              dateTime={blStatus.dlvrCarrDate}
              onDateTimeChange={dlvrCarrDate => onChange({dlvrCarrDate, dlvrCarrDateby: dlvrCarrDate ? blStatus.dlvrCarrDateby : '', isDlvrCarr: dlvrCarrDate ? blStatus.isDlvrCarr : false})}
              userId={blStatus.dlvrCarrDateby}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Doc. Package"
              disabled={isView}
              checked={!!blStatus.delAddrChk}
              onToggle={delAddrChk => onChange({
                delAddrChk,
                delAddrDate: delAddrChk ? now() : null,
                delAddrBy: delAddrChk ? user : '',
                })}
              dateTime={blStatus.delAddrDate}
              onDateTimeChange={delAddrDate => onChange({delAddrDate, delAddrBy: delAddrDate ? blStatus.delAddrBy : '', delAddrChk: delAddrDate ? blStatus.delAddrChk : false})}
              userId={blStatus.delAddrBy}
            />
          </InlineInputControlRowNoLabel>
        </div>
      </div>
    </div>
  );
}

export default React.memo(HblMilestone);
